import apiClient from '../utils/apiService';

/**
 * 财务报表主表相关 API
 */
export const monthlyReportApi = {
  // 查询主表分页
  queryPage: (params) => apiClient.post('/finance/monthly-report/page', params),
  
  // 更新主表
  update: (data) => apiClient.put('/finance/monthly-report/update', data),
  
  // 删除
  delete: (id) => apiClient.delete(`/finance/monthly-report/delete/${id}`),
};

/**
 * Agent BI 相关 API
 */
export const agentBiApi = {
  // 查询 Agent BI 分页
  queryPage: (params) => apiClient.post('/finance/monthly-report/agent-bi/page', params),
  
  // 更新 Agent BI 行
  updateRow: (data) => apiClient.put('/finance/monthly-report/agent-bi/update', data),
  
  // 导出 Agent BI
  export: (params) => apiClient.post(
    '/finance/monthly-report/agent-bi/export',
    params,
    { responseType: 'blob' }
  ),
};

/**
 * HBL BI 相关 API
 */
export const hblBiApi = {
  // 查询 HBL BI 分页
  queryPage: (params) => apiClient.post('/finance/monthly-report/hbl-bi/page', params),
  
  // 更新 HBL BI 行
  updateRow: (data) => apiClient.put('/finance/monthly-report/hbl-bi/update', data),
  
  // 导出 HBL BI
  export: (params) => apiClient.post(
    '/finance/monthly-report/hbl-bi/export',
    params,
    { responseType: 'blob' }
  ),
};

/**
 * 额外费用导入 API
 */
export const extraFeeApi = {
  // 导入 Excel（reportDate 格式 yyyy-MM，如 2026-05）
  import: (formData, reportDate) => {
    if (reportDate) formData.append('report_date', reportDate);
    return apiClient.post(
      '/finance/monthly-report/extra-fee/import',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
};

/**
 * BI 数据刷新 API
 */
export const refreshApi = {
  // 触发刷新
  trigger: (payload) => apiClient.post('/finance/monthly-report/refresh/trigger', payload),
};

export default {
  monthlyReport: monthlyReportApi,
  agentBi: agentBiApi,
  hblBi: hblBiApi,
  extraFee: extraFeeApi,
  refresh: refreshApi,
};